import store from '@/store/store';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import { SolicitacaoController } from './SolicitacaoController';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';

class NovaSolicitacaoController {
  public static async getTiposSolicitacao(
    nrVinculo: string = null,
    showLoading = true,
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'getTiposolicitacao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
    };

    if (Util.isEmptyOrBlank(params.NRVINCULOM)) {
      delete params.NRVINCULOM;
    }

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tipos: any[] = response.data.dataset.data;

      return tipos;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de solicitação!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getEscalasTrab(
    showLoading = true,
  ) {
    const route = 'getEscalaTrab';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const escalas: any[] = response.data.dataset.data;

      return escalas;
    } catch (err) {
      const message = 'Não foi possível carregar as escalas!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTurnos(
    nrEscala: string,
    showLoading = true,
  ) {
    const route = 'getTurnos';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRESCALATRABM: nrEscala,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const turnos: any[] = response.data.dataset.data;

      return turnos;
    } catch (err) {
      const message = 'Não foi possível carregar os turnos!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async solicitaAlteracao(
    row: any,
    showLoading = true,
    isEdit = false,
  ) {
    if(isEdit) {
      await this.editSolicitacao(row, showLoading);
    } else {
      await this.addSolicitacao(row, showLoading);
    }
  }

  public static async getOcupacoes(
    showLoading = true,
  ) {
    const route = 'getOcupacao';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const ocupacoes: any[] = response.data.dataset.data;

      return ocupacoes;
    } catch (err) {
      const message = 'Não foi possível carregar as ocupaçoes!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getMotivosOcupa(
    showLoading = true,
  ) {
    const route = 'getMotivoOcupa';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const motivos: any[] = response.data.dataset.data;

      return motivos;
    } catch (err) {
      const message = 'Não foi possível carregar os motivos!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipoAlteraSal(
    showLoading = true,
  ) {
    const route = 'getTipoAlteraSal';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tipos: any[] = response.data.dataset.data;

      return tipos;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de alteração salarial!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getModalidadeSalarial(
    showLoading = true,
  ) {
    const route = 'getModalidadeSalarial';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const modalidades: any[] = response.data.dataset.data;

      return modalidades;
    } catch (err) {
      const message = 'Não foi possível carregar as modalidades!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getUltimoSalario(
    nrVinculo: any,
    showLoading = true,
  ) {
    const route = 'getUltimoSalario';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const dados = response.data.dataset.data;

      if (dados.length === 0) {
        throw new Error();
      } else {
        return dados[0];
      }
    } catch (err) {
      const message = 'Ultimo Salário do Vínculo não encontrado.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTpAvisoPrevio(
    showLoading = true,
  ) {
    const route = 'getTpAvisoPrevio';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tipos: any[] = response.data.dataset.data;

      return tipos;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de aviso prévio!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTpDemissao(
    showLoading = true,
  ) {
    const route = 'getTpDemissao';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tipos: any[] = response.data.dataset.data;

      return tipos;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de demissão!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getMotivoResc(
    showLoading = true,
  ) {
    const route = 'getMotivoResc';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const motivos: any[] = response.data.dataset.data;

      return motivos;
    } catch (err) {
      const message = 'Não foi possível carregar os motivos de rescisão!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipoRelacionamento(
    showLoading = true,
  ) {
    const route = 'getTipoRelacionamento';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tiposRel: any[] = response.data.dataset.data;

      return tiposRel;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de relacionamento!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipoDependente(
    showLoading = true,
  ) {
    const route = 'getTipoDependente';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tiposDep: any[] = response.data.dataset.data;

      return tiposDep;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de dependente!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getLinhaTransporteAtiva(
    showLoading = true,
  ) {
    const route = 'getLinhaTransporteAtiva';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const linhas: any[] = response.data.dataset.data;

      return linhas;
    } catch (err) {
      const message = 'Não foi possível carregar as linhas!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipolinhavinc(
    showLoading = true,
  ) {
    const route = 'getTipolinhavinc';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tiposLinha: any[] = response.data.dataset.data;

      return tiposLinha;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de linha!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getIntegtransp(
    showLoading = true,
  ) {
    const route = 'getIntegtransp';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const numerosIntegracao: any[] = response.data.dataset.data;

      return numerosIntegracao;
    } catch (err) {
      const message = 'Não foi possível carregar os números de integração!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getSentidolinha(
    showLoading = true,
  ) {
    const route = 'getSentidolinha';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const sentidos: any[] = response.data.dataset.data;

      return sentidos;
    } catch (err) {
      const message = 'Não foi possível carregar os sentidos da linha!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getBeneficios(
    showLoading = true,
  ) {
    const route = 'getBeneficios';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const beneficios: any[] = response.data.dataset.data;

      return beneficios;
    } catch (err) {
      const message = 'Não foi possível carregar os benefícios!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getPessoaRelacionamentos(
    nrPessoa: string,
    showLoading = true,
  ) {
    const route = 'getPessoaRelacionamentos';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRPESSOA: nrPessoa,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const pessoas: any[] = response.data.dataset.data;

      return pessoas;
    } catch (err) {
      const message = 'Não foi possível carregar as pessoas!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getEstrutura(
    nmTipoEstrutura: string|number = null,
    showLoading = true,
  ) {
    const route = 'getEstrutura';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NMTIPOESTRUTURA: nmTipoEstrutura,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const estruturas: any[] = response.data.dataset.data;

      return estruturas;
    } catch (err) {
      const message = 'Não foi possível carregar as estruturas!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getEstruturas(
    nmTipoEstrutura: string = null,
    showLoading = true,
  ) {
    const route = 'getEstruturas';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NMTIPOESTRUTURA: nmTipoEstrutura,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const estruturas: any[] = response.data.dataset.data;

      return estruturas;
    } catch (err) {
      const message = 'Não foi possível carregar as estruturas!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getEstruturaAdicional(
    showLoading = true,
  ) {
    const route = 'getEstruturaAdicional';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const estruturas: any[] = response.data.dataset.data;

      return estruturas;
    } catch (err) {
      const message = 'Não foi possível carregar as estruturas!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getEstruturaAdicionalByTipo(
    showLoading = true,
  ) {
    const route = 'getEstruturaAdicionalByTipo';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const estruturas: any[] = response.data.dataset.data;

      return estruturas;
    } catch (err) {
      const message = 'Não foi possível carregar as estruturas!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTemplate(
    showLoading = true,
  ) {
    const route = 'getTemplate';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const templates: any[] = response.data.dataset.data;

      return templates;
    } catch (err) {
      const message = 'Não foi possível carregar os templates!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipoprocessos(
    showLoading = true,
  ) {
    const route = 'getTipoprocessos';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tipos: any[] = response.data.dataset.data;

      return tipos;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de processo!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getParcnegocioVinculos(
    showLoading = true,
  ) {
    const route = 'getParcnegocioVinculos';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const parcs: any[] = response.data.dataset.data;

      return parcs;
    } catch (err) {
      const message = 'Não foi possível carregar os responsáveis!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipoTransferencia(
    showLoading = true,
  ) {
    const route = 'getTipoTransferencia';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tipos: any[] = response.data.dataset.data;

      return tipos;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de transferência!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getMovimentacaoTransferencia(
    showLoading = true,
  ) {
    const route = 'getMovimentacaoTransferencia';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const transferencias: any[] = response.data.dataset.data;

      return transferencias;
    } catch (err) {
      const message = 'Não foi possível carregar as movimentações de transferência!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getMotivoTransferencia(
    showLoading = true,
  ) {
    const route = 'getMotivoTransferencia';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const motivos: any[] = response.data.dataset.data;

      return motivos;
    } catch (err) {
      const message = 'Não foi possível carregar os motivos de transferência!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getDadosPreviosSolicitacao(
    nrVinculo: number,
    nrTipoSolicitacao: number,
    showLoading = true,
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'getDadosPreviosSolicitacao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
      NRTIPOSOLICITACAO: nrTipoSolicitacao
    };

    if (Util.isEmptyOrBlank(params.NRVINCULOM)) {
      delete params.NRVINCULOM;
    }

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const dadosPrevios: any = response.data.dataset.data;

      return dadosPrevios;
    } catch (err) {
      const message = 'Não foi possível carregar os dados prévios da solicitação!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getSolicitacoesDia(
    row: any,
    isEdit = false,
    showLoading = true,
  ) {
    const route = 'getSolicitacoesDia';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        ...row,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);
      const solicitacoes: any = response.data.dataset.data;

      return solicitacoes;
    } catch (err) {
      const message = 'Não foi possível carregar as solicitações do dia!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async addSolicitacao(
    row: any,
    showLoading = true,
  ) {
    const route = 'solicitaAlteracao';

    const nrOrg: string = store.getters.user.nrorg;
    const cdOperador: string = store.getters.user.cdoperador;

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        ...row,
        CDOPERADOR: cdOperador,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);
      if (!response || !response.data) {
        throw new Error;
      }

      const success: boolean = response.data.dataset.data.success;
      const nrSolicitacao = response.data.dataset.data.nrsolicitacao;

      if (response.data && response.data.dataset.data.success) {
        SolicitacaoController.notificaProximosAprovadoresSolicitacao(
          nrSolicitacao, false
        );
      }

      return success;
    } catch (err) {
      const erro: any = err;

      let message = 'Não foi possível solicitar a alteração!';
      
      if(erro.response && erro.response.data) {
         message = erro.response.data.error;
      }
      
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async editSolicitacao(
    row: any,
    showLoading = true,
  ) {
    const route = 'editSolicitacao';

    const nrOrg: string = store.getters.user.nrorg;
    const cdOperador: string = store.getters.user.cdoperador;

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        ...row,
        CDOPERADOR: cdOperador,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);
      if (!response || !response.data) {
        throw new Error;
      }

      const success: boolean = response.data.dataset.data.success;
      const nrSolicitacao = row.NRSOLICITACAO;

      if (response.data && response.data.dataset.data.success) {
        SolicitacaoController.notificaProximosAprovadoresSolicitacao(
          nrSolicitacao, false
        );
      }

      return success;
    } catch (err) {
      const erro: any = err;

      let message = 'Não foi possível solicitar a alteração!';
      
      if(erro.response && erro.response.data) {
         message = erro.response.data.error;
      }
      
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getMotivoRecusa(
    nrsolicitacao: string = null,
    showLoading = true,
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'getMotivoRecusa';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRSOLICITACAO: nrsolicitacao,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const motivos: any[] = response.data.dataset.data;

      if(Util.isEmptyOrBlank(motivos)) {
        return null;
      }
      
      return motivos;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de solicitação!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  
  }
  public static async getTiposAnotacao(
    nrsolicitacao: string = null,
    showLoading = true,
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'getTiposAnotacao';
    
    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const motivos: any[] = response.data.dataset.data;

      if(Util.isEmptyOrBlank(motivos)) {
        return null;
      }
      
      return motivos;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de anotação!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
}

export default NovaSolicitacaoController;
